import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../_shared/services/base.service";

import { BasicDto } from "../../_shared/models/basicDto";
import { SaveVatSettingsDto, StartSettingListDto, StartSettingSmallOrgDto } from "../models/startsetting";

@Injectable({
  providedIn: "root",
})
export class StartsettingsService extends BaseService<
  StartSettingSmallOrgDto,
  StartSettingListDto
> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "startsettings");
  }

  getCurrent(): Observable<StartSettingSmallOrgDto> {
    return this.get<StartSettingSmallOrgDto>("/current");
  }

  saveWithDependencies(item: StartSettingSmallOrgDto): Observable<boolean> {
    return this.post<StartSettingSmallOrgDto, boolean>("/saveWithDependencies", item);
  }

  saveVatSettings(dto: SaveVatSettingsDto): Observable<boolean> {
    return this.post<SaveVatSettingsDto, boolean>("/saveVatSettings", dto);
  }

  hasNecessaryFields(): Observable<boolean> {
    return this.get<boolean>("/hasNecessaryFields");
  }

  forOrganization(orgKey: string): Observable<StartSettingSmallOrgDto> {
    return this.get<StartSettingSmallOrgDto>("/forOrganization?accessKey=" + orgKey);
  }

  forOrganizationId(organizationId: number): Observable<StartSettingSmallOrgDto> {
    return this.get(`/forOrganisation?id=${organizationId}`);
  }

  getOrganizationSorts(): Observable<BasicDto<number>[]> {
    return this.get<BasicDto<number>[]>("/organisationsorts");
  }
}
